const cartTokenLSKey = "cart_token";
const BUY_NOW_ISOLATED_CART_TYPE = "buy_now";
const BUY_NOW_CARTS_KEY = "buy-now-carts";
const BUY_NOW_CART_KEY_LENGTH = 6;
const BUY_NOW_CART_EXPIRED_ERROR_CODE = 404101;
const getCartToken = () => {
  return localStorage.getItem(cartTokenLSKey);
};
const setCartToken = (value) => {
  localStorage.setItem(cartTokenLSKey, value);
};
const removeCartToken = () => localStorage.removeItem(cartTokenLSKey);
const defaultCart = {
  id: "",
  items: [],
  priceSummary: [
    {
      name: "T\u1ED5ng ti\u1EC1n",
      value: "0\u0111"
    },
    {
      name: "Th\xE0nh ti\u1EC1n",
      value: "0\u0111"
    }
  ],
  grandTotalAmount: 0,
  paidAmount: 0,
  remainingAmount: 0,
  onDemandDiscount: 0,
  allowedUserActions: [],
  promotions: [],
  paymentMethods: [],
  orderTerminalCode: ""
};
const generateRandomString = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
let lastBuyNowKey = "";
const getBuyNowKey = (isReuse) => {
  if (isReuse) {
    return lastBuyNowKey;
  }
  const newBuyNowKey = generateRandomString(BUY_NOW_CART_KEY_LENGTH);
  lastBuyNowKey = newBuyNowKey;
  return newBuyNowKey;
};
const storeBuyNowCartKey = (newBuyNowCart) => {
  const buyNowCarts = JSON.parse(localStorage.getItem(BUY_NOW_CARTS_KEY) || "[]");
  buyNowCarts.push(newBuyNowCart);
  localStorage.setItem(BUY_NOW_CARTS_KEY, JSON.stringify(buyNowCarts));
};

export { BUY_NOW_CARTS_KEY, BUY_NOW_CART_EXPIRED_ERROR_CODE, BUY_NOW_CART_KEY_LENGTH, BUY_NOW_ISOLATED_CART_TYPE, defaultCart, getBuyNowKey, getCartToken, removeCartToken, setCartToken, storeBuyNowCartKey };
